import {
  hubspotOnFormReady as onFormReady,
  restyleHubspotForm as restyleForm,
  createForm,
} from '../../ably-ui/hubspot-forms';

interface FormConfig {
  formId: string;
  btn: string;
  container: string;
  title: string;
}

interface ConfigMap {
  supportAnonymous: FormConfig;
  support: FormConfig;
  incident: FormConfig;
}

const setupHubSpotForms = ({ userSignedIn }: { userSignedIn: boolean }) => {
  const config: ConfigMap = {
    supportAnonymous: {
      formId: 'edc0c193-801d-4410-8b30-35531a8ddbaf',
      btn: '#support-radio',
      container: '#hubspot-raise-a-ticket-form',
      title: 'Raise a support ticket',
    },
    support: {
      formId: '57de6eaf-7093-441e-97cc-f61292c96ac4',
      btn: '#support-radio',
      container: '#hubspot-raise-a-ticket-form',
      title: 'Raise a support ticket',
    },
    incident: {
      formId: '61e8853c-d5ba-4ad8-8a52-fc555c15cc0c',
      btn: '#incident-escalation-radio',
      container: '#hubspot-raise-a-incident-escalation-form',
      title: 'Incident escalation',
    },
  };

  const formKeys = Object.keys(config) as (keyof ConfigMap)[];
  const isContainerEmpty = (key: keyof ConfigMap) => {
    const container = document.querySelector(config[key].container);
    return container ? container.innerHTML === '' : true;
  };
  const getContainer = (key: keyof ConfigMap) => document.querySelector(config[key].container);

  const renderForm = (key: keyof ConfigMap) => {
    createForm({ formId: config[key].formId, target: config[key].container, onFormReady });
    restyleForm(`${config[key].container} > iframe`);
  };

  const showForm = (key: keyof ConfigMap) => {
    formKeys
      .filter((k) => k !== key)
      .forEach((k) => {
        const container = getContainer(k);
        if (container) container.classList.add('hidden');
      });
    const container = getContainer(key);
    if (container) container.classList.remove('hidden');

    if (isContainerEmpty(key)) renderForm(key);
  };

  const supportBtn = document.querySelector('[data-id="raise-a-support-ticket-btn"]');
  const enterpriseSupportBtn = document.querySelector('[data-id="raise-a-support-ticket-enterprise-btn"]');
  const enterpriseForm = document.querySelector('[data-id="hubspot-choose-form"]');

  if (supportBtn) {
    const supportBtnText = (supportBtn as HTMLElement).innerText;

    if (userSignedIn) {
      renderForm('support');
    } else {
      renderForm('supportAnonymous');
    }

    supportBtn.addEventListener('click', () => {
      const container = getContainer('support');

      if (container && container.classList.contains('hidden')) {
        container.classList.remove('hidden');
        (supportBtn as HTMLElement).innerText = 'Hide support ticket form';
      } else if (container) {
        container.classList.add('hidden');
        (supportBtn as HTMLElement).innerText = supportBtnText;
      }
    });
  }

  if (enterpriseSupportBtn) {
    const enterpriseSupportBtnText = (enterpriseSupportBtn as HTMLElement).innerText;
    const severityForms = formKeys.slice(1);

    severityForms.forEach((key) => {
      const btn = document.querySelector(config[key].btn);

      if (btn) {
        renderForm(key);
        btn.addEventListener('click', () => showForm(key));
      }
    });

    enterpriseSupportBtn.addEventListener('click', () => {
      if (enterpriseForm && enterpriseForm.classList.contains('hidden')) {
        enterpriseForm.classList.remove('hidden');
        const supportContainer = getContainer('support');
        if (supportContainer) supportContainer.classList.remove('hidden');
        const supportRadio = document.querySelector('#support-radio');
        if (supportRadio) (supportRadio as HTMLInputElement).checked = true;
        (enterpriseSupportBtn as HTMLElement).innerText = 'Hide support ticket form';
      } else if (enterpriseForm) {
        enterpriseForm.classList.add('hidden');
        formKeys.forEach((k) => {
          const container = getContainer(k);
          if (container) container.classList.add('hidden');
        });
        (enterpriseSupportBtn as HTMLElement).innerText = enterpriseSupportBtnText;
      }
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const userSignedIn = document.body.dataset.signedIn === 'true';

  setupHubSpotForms({ userSignedIn });
});
